__turbopack_context__.v({
  "active": "tab-module__WqP14W__active",
  "button": "tab-module__WqP14W__button",
  "wrapper": "tab-module__WqP14W__wrapper",
});
